import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { CalendarCheck, Mail } from "lucide-react";
import { SITE } from "@/lib/site";
import { useAppointment } from "@/components/AppointmentContext";

export default function FloatingCTA() {
  const { openDialog } = useAppointment();
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 600);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: 30 }}
          className="fixed bottom-5 right-5 z-40 flex flex-col items-end gap-3"
          data-testid="floating-cta"
        >
          <a href={SITE.emailHref} aria-label="Email us" data-testid="floating-email-btn"
            className="grid h-12 w-12 place-items-center rounded-full glass shadow-soft text-navy hover:text-teal hover:-translate-y-1 transition-all">
            <Mail className="h-5 w-5" />
          </a>
          <button onClick={openDialog} data-testid="floating-schedule-btn"
            className="group flex items-center gap-2 rounded-full bg-teal text-white pl-5 pr-6 h-13 py-4 shadow-premium hover:bg-teal-dark hover:-translate-y-1 transition-all">
            <CalendarCheck className="h-5 w-5" />
            <span className="text-sm font-medium">Free Consult</span>
          </button>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
